import React from "react";
import { Controller, useFormContext } from "react-hook-form";

import { AgentVersionConfigurationInput } from "src/agents/types";
import { Card } from "src/base-components/Card";
import { CodeEditor } from "src/base-components/CodeInput/CodeEditor";
import { FormItem } from "src/base-components/FormItem";

type AgentOutputSchemaEditorProps = {
  immutable: boolean;
};

export const AgentOutputSchemaEditor: React.FC<
  AgentOutputSchemaEditorProps
> = ({ immutable }) => {
  const { control } = useFormContext<AgentVersionConfigurationInput>();

  return (
    <Card className="w-full pb-4 pt-4">
      <FormItem>
        <FormItem.Label
          className="mb-2"
          description="Define the expected output schema for the agent's response. This will be used to validate and structure the agent's output."
        >
          Output Schema
        </FormItem.Label>
        <Controller
          control={control}
          name="output_schema"
          render={({ field }) => (
            <div className="h-60">
              <CodeEditor
                backgroundColor="white"
                basicSetup={{
                  lineNumbers: true,
                  highlightActiveLine: true,
                }}
                dataLoc="output-schema-json-editor"
                drawErrorBorder={false}
                fontFamily="inter"
                language="json"
                readOnly={immutable}
                value={
                  typeof field.value === "string"
                    ? field.value
                    : JSON.stringify(field.value || {}, null, 2)
                }
                lineWrapping
                onChange={(value) => {
                  if (!value || value.trim() === "") {
                    field.onChange({});
                    return;
                  }
                  try {
                    const parsed = JSON.parse(value);
                    field.onChange(parsed);
                  } catch {
                    // Silently fail for invalid JSON during editing
                    return;
                  }
                }}
              />
            </div>
          )}
        />
      </FormItem>
    </Card>
  );
};
